// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"187":"fa0ddc5b","481":"953510a1"}[chunkId] + ".css";
};